document.querySelectorAll('.aside-image').forEach(function(el) {
  if (el.querySelector('img') || el.querySelector('ul')) {
    const divEl = document.createElement('div');
    divEl.classList.add('element--before');
    el.prepend(divEl);
  }
  if (el.querySelector('.aside-quote')) {
    const divEl = document.createElement('div');
    divEl.classList.add('element--quote');
    el.prepend(divEl);
  }
  if (el.querySelector('.aside-author')) {
    const divEl = document.createElement('div');
    divEl.classList.add('element--before');
    el.prepend(divEl);
  }
});

$('.aside-image--hover').on('mouseenter', function () {
  $(this).parent('p').prev('.aside-image').addClass('aside-image--hovered');

  if (isScrolling) return;
  var $artID = $(this).parents('.__js_stats_wrapper').data('id');
  var ga360id = $(this).data('ga360-id');
  var dataid = $(this).data('id');
  if (ga360id !== undefined) {
    sendStats('aside-image', 'open_aside-image', $artID, 'proba');
    if (!isScrolligFlag) {
      custom360Action({
        event: 'content_interaction',
        eventCategory: ga360id,
        moduleName: dataid,
        eventAction: deviceTouch ? 'tap' : 'hover',
      });
    }
  } else {
    console.log('%c dodać ga360-id do Aside-image hover: ' + $(this).data('id'), 'background: #553311; padding: 3px; color: #ffaaaa');
  }
});

$('.aside-image--hover').on('mouseleave', function () {
  $(this).parent('p').prev('.aside-image').removeClass('aside-image--hovered');
});

var galleriesHover = $(".aside-image-hover").each(function () {
  var $artID = $(this).parents('.__js_stats_wrapper').data('id');
  var ga360id = $(this).data('ga360-id');
  if (ga360id === undefined) {
    console.log('%c dodać ga360-id do Aside-image hover: ' + $(this).data('id'), 'background: #553311; padding: 3px; color: #ffaaaa');
  } else {
    statElementCollector[ga360id + '-' + $artID] = {
      id: ga360id,
      moduleName: $(this).data('id'),
      viewedCount: 0,
    };
  }
  $(this).statVievedSlide = [];
  slidePositionVieved[ga360id + '-' + $artID] = {};
});

// DEBUG - odsłania wszystkie elementy aside (do pracy nad stylami, usunąć przed oddaniem)
document.querySelectorAll('.aside-image').forEach((el) => el.classList.add('aside-image--hovered'));
